import React from "react";

interface EmailLinkProps {
	body?: string;
	email: string;
	overrideText?: string;
	subject?: string;
}

export const EmailLink: React.FC<EmailLinkProps> = ({
	email,
	subject,
	body,
	overrideText,
}) => {
	// Build query string for body if provided
	const queryParams = new URLSearchParams();
	if (body) {
		queryParams.append("body", encodeURIComponent(body));
	}

	const subjectString = subject ? `?subject=${subject}` : "";
	const bodyString = queryParams
		? `${subject ? "&" : "?"}${queryParams.toString()}`
		: "";

	const href = `mailto:${email}${subjectString}${bodyString}`;

	return <a href={href}>{overrideText || email}</a>;
};
